/* eslint-disable no-unused-vars */
import SupervisorService from '_services/rest/modules/supervisor';

export default {
  state: {
    supervisor: null,
    supervisorList: null,
    detachedDistributors: null,
    attachedDistributors: null,
    allAttachedDistributors: null,
  },
  mutations: {
    setSupervisorList(state, response) {
      state.supervisorList = response;
    },
    setSupervisor(state, response) {
      state.supervisor = response;
    },
    setDetachedDistributors(state, response) {
      state.detachedDistributors = response;
    },
    setAttachedDistributors(state, response) {
      state.attachedDistributors = response;
    },
    setAllAttachedDistributors(state, response) {
      state.allAttachedDistributors = response;
    },
  },
  actions: {
    getSupervisorList({ commit }, params) {
      return SupervisorService.getList(params).then(response => {
        commit('setSupervisorList', response);
      });
    },

    getSupervisor({ commit }, params) {
      return SupervisorService.getSupervisorById(params)
        .then(supervisor => {
          commit('setSupervisor', supervisor);
          return supervisor;
        })
        .catch(error => {
          throw error.message;
        });
    },

    editSupervisor({ commit }, params) {
      return SupervisorService.save(params);
    },

    deleteSupervisor({ commit }, params) {
      return SupervisorService.delete(params);
    },

    getSupervisorDistributors({ commit }, params) {
      if (!params.search && params.group === 'attached') {
        return SupervisorService.getSupervisorDistributors({
          ...params,
          take: 0,
        }).then(response => {
          if (params.page === 1) commit('setAllAttachedDistributors', response);
          commit('setAttachedDistributors', response);
          return response;
        });
      }

      return SupervisorService.getSupervisorDistributors(params).then(
        response => {
          if (params.group && params.group === 'attached') {
            if (!params.search) {
              commit('setAllAttachedDistributors', response);
            }
            commit('setAttachedDistributors', response);
            return response;
          }
          commit('setDetachedDistributors', response);
          return response;
        }
      );
    },

    syncAttacherSupervisorDistributors(
      { commit },
      { attachedDistributor, id }
    ) {
      const resellers = attachedDistributor.map(reseller => ({
        id: reseller.id,
      }));
      commit('setAllAttachedDistributors', {
        total_items: attachedDistributor.length,
        pages: Math.ceil(attachedDistributor.length / 10),
        list: attachedDistributor
      });
      return SupervisorService.syncResellers({
        id,
        resellers,
      });
    },
  },
};
